"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsButtonGroup = void 0;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Renders a group of buttons using Material-UI ButtonGroup.
 * 
 * @component
 * @param {Object} props Props for configuring the button group
 * @param {boolean} props.vertical If true, arranges buttons vertically
 * @param {boolean} props.small If true, sets button size to small
 * @param {boolean} props.large If true, sets button size to large
 * @param {React.ReactNode} props.children Buttons or components to be rendered within the group
 */
const DmsButtonGroup = _ref => {
  let {
    vertical = false,
    small = false,
    large = false,
    sx,
    children
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_material.ButtonGroup, {
    sx: _objectSpread({}, sx),
    orientation: vertical ? 'vertical' : 'horizontal',
    size: small ? 'small' : large ? 'large' : 'medium'
  }, children);
};
exports.DmsButtonGroup = DmsButtonGroup;